@if (loadingError) {
<div class="d-flex flex-column justify-content-center align-items-center w-100 vh-80">
    <div class="d-flex align-items-center">
        <h4>Fejl under indlæsning af sproglag.</h4> &nbsp;
        <i class="fa fa-exclamation-triangle fa-2x text-danger ml-2"></i>
    </div>
</div>
}@else if(isLoading)
{
<div class="d-flex flex-column justify-content-center align-items-center w-100 vh-80">
    <div class="continuous-loader" role="status"></div>
    <h4 class="mt-2">Indlæser sproglag</h4>
</div>
}
@else
{
<div class="card vh-80 mt-4" style="min-width: 1000px;">
    <div class="card-header">
        <div class="d-flex flex-row">
            <h5 class="card-title mt-1 flex-grow-1 ">Oversættelser
                @if(urlFeltNavn) {
                <span class="badge text-bg-primary fw-normal ms-1">Feltnavn: {{urlFeltNavn | uppercase}}</span>
                } @if (urlVaerdi) {
                <span class="badge text-bg-secondary fw-normal ms-1">Værdi: {{urlVaerdi}}</span>
                }
            </h5>
            <div class="d-flex flex-row ms-3 gap-2">
                <div class="form-check form-switch mt-1">
                    <input [(ngModel)]="searchSelectedFieldname" class="form-check-input" type="checkbox" role="switch"
                        id="flexSwitchCheckDefault">
                    <label class="form-check-label" style="text-wrap: nowrap;" for="flexSwitchCheckDefault">Søg feltnavn
                        under opret</label>
                </div>
                <div class="btn-group" role="group">
                    <button type="button" disabled class="btn btn-outline-primary" style="text-wrap: nowrap;">
                        Se redigeret</button>
                    <input type="radio" class="btn-check" name="date-radio" id="foer" autocomplete="off"
                        [(ngModel)]="isBefore" [value]="true" (ngModelChange)="this.currentPage = 1; search()">
                    <label class="btn btn-outline-primary" for="foer">Før</label>
                    <input type="radio" class="btn-check" name="date-radio" id="efter" autocomplete="off"
                        [(ngModel)]="isBefore" [value]="false" (ngModelChange)="this.currentPage = 1; search()">
                    <label class="btn btn-outline-primary" for="efter">Efter</label>
                </div>
                <input type="date" placeholder="dd-mm-yyyy" class="form-control" id="date" name="produktionsdato"
                    [formControl]="dateControl" autocomplete="off" style="max-width: fit-content;" />
                @if(!editAllowed) {
                <button class="btn btn-primary" (click)="searchForLatestImportDate()" style="max-width: fit-content;"
                    title="Se ændringer fra sidste import">
                    <span style="display: flex; align-items: center; gap: 2px;">
                        <i class="fa-solid fa-magnifying-glass fa-xs"></i>
                        <i class="fa-solid fa-calendar-arrow-down"></i>
                    </span>
                </button>
                }
                <div class="input-group" style="min-width: 350px;">
                    <input type="text" class="form-control" placeholder="Global søgning"
                        [formControl]="searchControlGlobal" />
                    <button class="btn btn-outline-secondary rounded-end" type="button" [ngbTooltip]="tooltipTemplate"
                        placement="bottom" [openDelay]="500">
                        <i class="fa-solid fa-circle-info"></i>
                    </button>
                </div>
                <ng-template #tooltipTemplate>
                    <div class="tooltip-content">
                        <div class="fw-bold mb-2">Søge syntaks:</div>
                        <div class="mb-1">• <code>"exact"</code> - eksakt match</div>
                        <div class="mb-1">• <code>^term</code> - starter med term</div>
                        <div class="mb-1">• <code>term$</code> - slutter med term</div>
                        <div class="mb-1">• <code>wild*card</code> - * = flere tegn</div>
                        <div class="mb-1">• <code>wild?card</code> - ? = ét tegn</div>
                        <div class="mb-1">• <code>\* \?</code> - søg efter * eller ? tegn</div>
                        <div class="mb-1">• <code>term1||term2</code> - ELLER (OR)</div>
                        <div class="mb-1">• <code>term1&&term2</code> - OG (AND)</div>
                        <div class="mb-1">• <code>a&&b||c</code> - (a OG b) ELLER c</div>
                        <div class="mb-1">• <code>:empty</code> - finder tomme felter</div>
                    </div>
                </ng-template>
                <button class="btn btn-primary" (click)="clearFilters()" title="Ryd alle filtre">
                    <i class="fa-regular fa-filter-circle-xmark"></i>
                </button>
            </div>
        </div>
    </div>
    <div class="card-body p-0"
        style="max-width: calc(100vw - 165px); max-height: calc(100vh - 280px); overflow: hidden; display: flex; flex-direction: column;">
        <!-- Top bar -->
        <div class="top-bar d-flex align-items-center bg-light" style="width: 100%; border-bottom: 1px solid #ccc;">
            <div class="d-flex align-items-center p-3 translation-column-width">
                <h6 class="me-3 mb-1">Feltnavn</h6>
                <input type="text" class="form-control me-2" placeholder="Søg Feltnavn..."
                    [formControl]="searchControlFieldname" />
            </div>
            <div class="vr"></div>
            @for (cultureId of cultureIds; track $index) {
            <div class="d-flex align-items-center p-3 translation-column-width">
                <h6 class="me-3 mb-1" style="white-space: nowrap;">{{ cultureIds[$index] }}</h6>
                @if (searchControlsForCultureIds.at($index); as searchControl) {
                <input type="text" class="form-control me-2" placeholder="Søg i sprogværdi..."
                    [formControl]="searchControl" />
                }
            </div>
            }
        </div>
        <div style="display: flex; flex-grow: 1; overflow: hidden;">
            <div #fieldNames id="constant-column" class="bg-light-subtle translation-column-width"
                style="padding-bottom: 16px;">
                @for (map of visibleItems; track $index) {
                <div class="d-flex align-items-center translation-row-padding" [ngClass]="{'edited': map.isEdited}"
                    [ngStyle]="{'border-left': '4px solid ' + (map.updatedOn | dateColor: latestImportDate)}">
                    <div class="input-group">
                        <input id="fieldName{{$index}}" #constantInput type="text" [ngModel]="map.feltNavn"
                            class="form-control" (paste)="handleCsvPaste($event, map)" [readOnly]="!editAllowed"
                            (keydown)="keydownFieldname($event, map)" (input)="formatFieldNameInput($event, map);"
                            (ngModelChange)="markEdited(map, 'key')"
                            [tabIndex]="$index | tabIndex: 0 : cultureIds.length"
                            [disabled]="map.waitingForNetwork ?? false" />
                        <button class="btn btn-outline-secondary dropdown-toggle" type="button"
                            data-bs-toggle="dropdown" aria-expanded="false" [disabled]="map.waitingForNetwork">
                            <i class="fa-regular fa-gear" [ngClass]="{'fa-spin' : map.waitingForNetwork}"></i>
                        </button>
                        <ul class="dropdown-menu dropdown-menu-end">
                            <li class="dropdown-item text-muted">
                                <small>Opdateret den: {{ map.updatedOn | date:'dd-MM-yyyy HH:mm' }}</small>
                            </li>
                            <hr class="dropdown-divider">
                            @if(editAllowed) {
                            <li><a class="dropdown-item" (click)="save([map])">
                                    <i class="fas fa-save"></i> Gem</a></li>
                            }
                            <li><a class="dropdown-item" (click)="copyToClipboard(map.feltNavn)">
                                    <i class="fa-regular fa-copy"></i> Kopier | terms (ctrl+shift+c)</a></li>
                            @if(editAllowed) {
                            <hr class="dropdown-divider">
                            <li><a class="dropdown-item" (click)="deleteTranslation(map)">
                                    <i class="fas fa-trash text-danger"></i> Slet</a></li>
                            }
                        </ul>
                    </div>
                    @if (map.errorMessage) {
                    <i class="fa-solid fa-triangle-exclamation text-danger ms-2"
                        [ngbTooltip]="map.errorMessage" placement="right"></i>
                    }
                </div>
                } @empty {

                }
            </div>
            <div class="vr" style="min-width: 1px;"></div>
            <div #scrollableContent style="overflow-y: hidden; overflow-x: auto; min-width: calc(100vw - 565px);">
                <div class="row m-0 flex-nowrap">
                    @if(visibleItems.length > 0) {
                    @for (cultureId of cultureIds; track $index; let colIndex = $index) {
                    <div class="col translation-column-width">
                        @for (map of visibleItems; track $index; let rowIndex = $index;) {
                        @let sproglag = map.languageMap[cultureId];
                        <app-translations-field [readOnly]="!editAllowed" [sprogLag]="sproglag" [cultureId]="cultureId"
                            [cultureIds]="cultureIds" [translationContext]="map" [isEdited]="map.isEdited ?? false"
                            [tabIndex]="rowIndex | tabIndex: colIndex + 1 : cultureIds.length"
                            (markEdited)="markEdited(map, 'field')"
                            (translateEmptyFields)="translateEmptyFields(map, sproglag)" />
                        }
                    </div>
                    }
                    } @else {
                    <div class="d-flex justify-content-center align-items-center w-100 vh-80">
                        <h4>Ingen resultater fundet</h4>
                    </div>
                    }
                </div>
            </div>
        </div>
    </div>
    <div class="card-footer" style="display: flex; justify-content: space-between; align-items: center;">
        @if(editAllowed) {
        <button class="btn btn-primary" (click)="addNewTranslation()">
            Tilføj ny oversættelse (alt+n)
        </button>
        }
        @if(totalPages > 0) {
        <div style="flex-grow: 1; display: flex; justify-content: center;">
            <app-pagination-list-footer [totalPages]="totalPages" [currentPage]="currentPage"
                (goToPage)="goToPage($event)" />
        </div>
        }
        @if(editAllowed) {
        <button class="btn btn-success" (click)="saveAll()" style="margin-left: auto;">
            Gem Alle (ctrl+s)
        </button>
        }
    </div>
</div>
}